import { getStore } from '../store';

export const RESET_REDUX_STORE = 'RESET_REDUX_STORE';

export const storeProvider = (): { resetStore: () => void } => {
  const { dispatch } = getStore();
  return {
    resetStore: (): void => {
      dispatch({ type: RESET_REDUX_STORE });
    },
  };
};
